/**
 * @fileoverview Connect staff note editing to the matter's recorded activity history. The backend owns note/actor identity and accepted writes; the parent owns timeline refresh. Local draft text and deleting a saved note are distinct actions from simply inspecting the timeline.
 */

import React, { useContext, useEffect, useState } from 'react';
import api from '../../../api';
import { AppButton, AppModal, AppTextarea } from '../../shared';
import ToastContext from '../../../ToastContext';



function AddNoteForm({ noteForm, setNoteForm, matterNumber, fetchActivities }) {
    const showToast = useContext(ToastContext);

    const [noteContent, setNoteContent] = useState('')
    const [user, setUser] = useState(null);

    useEffect(() => {
        api.get('/user').then(response => {
            setUser(response.data);
            console.log(response.data);
        }).catch(error => {
            console.error(error);
        });
    }, []);

    useEffect(() => {
        console.log(noteForm);
        setNoteContent(noteForm.currentNote);
    }, [noteForm]);

    const submit =

    () => {
        console.log('submit');
        const payload = {
            ActivityType: 'Note',
            Date: new Date(noteForm.date) || new Date(),
            Details: noteContent,
            AttorneyName: user.Name,
            MatterNumber: matterNumber,
            id: noteForm.currentNoteId
        };

        const apiMethod = noteForm.isEditing ? api.put : api.post;
        const endpoint = noteForm.isEditing ? `/activity/${noteForm.currentNote.id}` : `/activity`;

        apiMethod(endpoint, payload)
            .then(

            response => {
                console.log(response.data);
                fetchActivities();
                showToast({
                    severity: 'success',
                    summary: 'Successful',
                    detail: noteForm.isEditing ? 'Note updated' : 'Note added to activity log'
                });
                setNoteForm({
                    visible: false,
                    isEditing: false,
                    currentNote: null
                });
            })
            .catch(error => {
                console.error('Error:', error);
                showToast({ severity: 'error', summary: 'Error', detail: error.message });
            });
    }

    const deleteNote =

    () => {
        api.delete('/activity', { data: { id: noteForm.currentNoteId } })
            .then(response => {
                if (response.status === 201) {  // Added status check
                    fetchActivities();
                    showToast({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Note deleted'
                    });
                    setNoteForm({
                        ...noteForm,
                        visible: false,
                        isEditing: false,
                        currentNote: null
                    });
                } else {
                    showToast({ severity: 'error', summary: 'Error', detail: 'Unexpected status code' });
                }
            })
            .catch(error => {
                console.error('Error:', error);
                showToast({ severity: 'error', summary: 'Error', detail: error.message });
            });
    }

    const footerContent = (
        <div className="case-details-modal__actions">
            {noteForm.isEditing && <AppButton label="Delete" icon="pi pi-trash" variant="danger" onClick={deleteNote} />}
            <AppButton label={noteForm.isEditing ? 'Update' : 'Submit'} icon="pi pi-check" onClick={submit} autoFocus />
        </div>
    );

    return (
        <>
            <AppModal title={noteForm.isEditing ? 'Edit Note' : 'Add Note'}
                description="Write or revise a case activity note without leaving the timeline."
                visible={noteForm.visible}
                width="min(92vw, 760px)"
                onClose={() => setNoteForm({ ...noteForm, visible: false })}
                footer={footerContent}
                className="case-details-modal">
                <div className="case-details-modal__form">
                    <section className="case-details-modal__section">
                        <div className="case-details-modal__section-header">
                            <div>
                                <h3 className="case-details-modal__section-title">Note Details</h3>
                                <p className="case-details-modal__section-description">
                                    Capture the internal context that should appear in the activity log for this matter.
                                </p>
                            </div>
                        </div>
                        <div className="case-details-modal__section-body">
                            <div className="case-details-modal__field">
                                <label htmlFor="noteContent" className="case-details-modal__label">Note</label>
                                <AppTextarea id="noteContent" value={noteContent} onChange={(val) => setNoteContent(val)} rows={8} />
                            </div>
                        </div>
                    </section>
                </div>
            </AppModal>
        </>
    )
}

export default AddNoteForm
